<div [ngClass]="fuseConfig.layout.navbar.primaryBackground" id="header-pading"> 

    <fuse-navigation layout="horizontal"></fuse-navigation>
    
</div>